import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { List, X } from "@phosphor-icons/react";

const links = [
    { to: "/", label: "Home" },
    { to: "/packages", label: "Packages" },
    { to: "/become-poster", label: "Become a Poster" },
    { to: "/schedule", label: "Schedule Campaign" },
    { to: "/contact", label: "Contact" },
];

export default function Navbar() {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const { pathname } = useLocation();

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => setOpen(false), [pathname]);

    return (
        <header
            className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
                scrolled || pathname !== "/"
                    ? "bg-[#0A192F]/95 backdrop-blur-md border-b border-white/10"
                    : "bg-transparent"
            }`}
            data-testid="site-navbar"
        >
            <nav className="max-w-7xl mx-auto px-6 md:px-8 h-20 md:h-28 flex items-center justify-between">
                <Link to="/" className="flex items-center gap-3.5" data-testid="navbar-logo-link">
                    <img src="/logo.png" alt="CashFlow Ads" className="w-14 h-14 md:w-[68px] md:h-[68px] rounded-full object-cover bg-white shadow-xl shadow-black/30 ring-2 ring-[#D4AF37]/50" />
                    <div className="leading-tight">
                        <div className="text-white font-display font-extrabold tracking-tight text-xl md:text-3xl uppercase">
                            CashFlow <span className="text-[#D4AF37]">Ads</span>
                        </div>
                        <div className="text-[10px] md:text-[11px] uppercase tracking-[0.22em] text-[#D4AF37]/90 font-semibold">
                            Where Reach Becomes Revenue
                        </div>
                    </div>
                </Link>

                <div className="hidden md:flex items-center gap-1">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                            className={({ isActive }) =>
                                `relative px-4 py-2 text-sm font-medium transition-colors ${
                                    isActive ? "text-[#D4AF37]" : "text-white/80 hover:text-white"
                                }`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                </div>

                <Link
                    to="/schedule"
                    className="hidden md:inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#D4AF37] hover:bg-[#e3c14a] text-[#0A192F] font-semibold text-sm transition-all shadow-lg shadow-[#D4AF37]/20 hover:shadow-xl hover:shadow-[#D4AF37]/30"
                    data-testid="navbar-cta-button"
                >
                    Launch Campaign →
                </Link>

                <button
                    className="md:hidden text-white p-2"
                    onClick={() => setOpen(!open)}
                    aria-label="Toggle menu"
                    data-testid="navbar-mobile-toggle"
                >
                    {open ? <X size={26} /> : <List size={26} />}
                </button>
            </nav>

            {open && (
                <div className="md:hidden bg-[#0A192F] border-t border-white/10 px-6 py-4" data-testid="navbar-mobile-menu">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            className={({ isActive }) =>
                                `block py-3 text-base font-medium border-b border-white/5 last:border-0 ${
                                    isActive ? "text-[#D4AF37]" : "text-white/85"
                                }`
                            }
                            data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                        >
                            {l.label}
                        </NavLink>
                    ))}
                    <Link
                        to="/schedule"
                        className="mt-4 block w-full text-center px-5 py-3 rounded-full bg-[#D4AF37] text-[#0A192F] font-semibold"
                        data-testid="navbar-mobile-cta"
                    >
                        Launch Campaign
                    </Link>
                </div>
            )}
        </header>
    );
}
